import ColorApp from "../color/color";

function DonatOptions() {
  return {
    colors: ["rgba(" + ColorApp().themeColor + ", 0.15)", ColorApp().themeColor],
    chart: { sparkline: { enabled: true } },
    stroke: { show: false },
    tooltip: {
      x: { show: false },
      y: {
        title: {
          formatter: function (seriesName) {
            return "";
          },
        },
      },
    },
  };
}

export default DonatOptions;
